import { GridLayout } from '@view-model/ui/layouts';

export const VIEW_GRID_SIZE = 512; // ビューのサイズ変更単位
export const MIN_VIEW_WIDTH = VIEW_GRID_SIZE * 2;
export const MIN_VIEW_HEIGHT = VIEW_GRID_SIZE * 3;

export const viewGridLayout = new GridLayout(VIEW_GRID_SIZE, VIEW_GRID_SIZE);
